module.exports = __webpack_public_path__ + "img/emoji-finger-down.5653d59f.png";